import { after, before } from 'glamor'

import { borders as borderColors } from './theme-colors'

// Paddings, Margins
export const spacing = {
  xSmall: '5px',
  small: '10px',
  medium: '15px',
  large: '20px',
  xLarge: '30px',
  xxLarge: '80px',
}

export const content = {
  maxWidth: '80ex',
}

// Box Shadows
export const shadows = {
  regular: '0 2px 4px 0 rgba(64, 78, 89, 0.1)',
  medium: ' 0 2px 8px 0 rgba(64, 78, 89, 0.25)',

  elevation: [
    '0 1px 2px 0 rgba(64, 78, 89, 0.05)',
    '0 2px 4px 0 rgba(64, 78, 89, 0.1)',
    '0 4px 8px 0 rgba(64, 78, 89, 0.1)',
    '0 8px 12px 0 rgba(64, 78, 89, 0.1)',
  ],

  depression: [
    'inset 0 1px 2px 0 rgba(64, 78, 89, 0.05)',
    'inset 0 2px 4px 0 rgba(64, 78, 89, 0.1)',
    'inset 0 4px 8px 0 rgba(64, 78, 89, 0.1)',
    'inset 0 8px 12px 0 rgba(64, 78, 89, 0.1)',
  ],
}

export const typography = {
  weights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
  },

  sizes: {
    small: '11px',
    medium: '13px',
    large: '24px',
    huge: '42px',
  },

  lineHeights: {
    small: '20px',
    medium: '30px',
    large: '50px',
  },

  fontFamilies: {
    main: "europa, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    monospace: "'SF Mono', 'Monaco', 'Inconsolata', 'Fira Mono', 'Droid Sans Mono', 'Source Code Pro', monospace",
  },
}

export const borders = {
  regular: `1px solid ${borderColors.regular}`,
  primary: `1px solid ${borderColors.primary}`,
  dim: `1px solid ${borderColors.dim}`,
}

export const borderRadiuses = {
  regular: '4px',
  large: '6px',
}

export const timingFunctions = {
  easeInOutQuad: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
  easeInOutBack: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
}

export const transitions = {
  regular: `250ms ${timingFunctions.easeInOutQuad}`,
  regularFast: `150ms ${timingFunctions.easeInOutQuad}`,
  regularSlow: `350ms ${timingFunctions.easeInOutQuad}`,

  bouncy: `250ms ${timingFunctions.easeInOutBack}`,
  bouncyFast: `150ms ${timingFunctions.easeInOutBack}`,
  bouncySlow: `350ms ${timingFunctions.easeInOutBack}`,
}

export const focus = {
  outline: 0,
  boxShadow: 'inset 0 0 0 1px #9ecbff',
}

export const focusWithinStyles = {
  ':focus-within': {
    ...focus,
  },
}

export const createFocusStyles = (extra = {}) => ({
  '&:focus': {
    ...focus,
    ...extra,
  },
})

export const focusStyles = createFocusStyles()

export const zLayers = {
  foreground: 7500,
  topmost: 10000,
  portal: 20000,
}

const sharedArrowStyles = {
  content: ' ',
  position: 'absolute',
  display: 'block',
}

export const arrowUp = {
  ...before({
    ...sharedArrowStyles,
    borderLeft: '7px solid transparent',
    borderRight: '7px solid transparent',
    borderBottom: '7px solid white',
    left: 'calc(50% - 7px)',
    width: '9px',
    height: '9px',
    top: '-8px',
    zIndex: '1',
  }),
  ...after({
    ...sharedArrowStyles,
    left: 'calc(50% - 8px)',
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderBottom: '8px solid rgba(64, 78, 89, 0.13)',
    width: '10px',
    height: '10px',
    top: '-9px',
  }),
}
export const arrowDown = {
  ...before({
    ...sharedArrowStyles,
    borderLeft: '7px solid transparent',
    borderRight: '7px solid transparent',
    borderTop: '7px solid white',
    left: 'calc(50% - 7px)',
    zIndex: '1',
    width: '9px',
    height: '9px',
    bottom: '-8px',
    top: 'auto',
  }),
  ...after({
    ...sharedArrowStyles,
    left: 'calc(50% - 8px)',
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderTop: '8px solid rgba(64, 78, 89, 0.13)',
    width: '10px',
    height: '10px',
    bottom: '-9px',
    top: 'auto',
  }),
}
